import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { queryAllApi } from '../../../api';
import styles from './index.module.scss';
// import MainProductItem from '../../../components/MainProductItem/index';
import SubProductItem from '../../../components/SubProductItem/index';

interface ProductType {
  title: string,
  apiId: number,
  description: string,
  [x: string]: any
}

const ProductHome: React.FC = () => {
  const { t } = useTranslation();
  const [productData, setProductData] = useState<ProductType[]>([]);

  const handlerQueryAllApi = async () => {
    const result: any = await queryAllApi();
    console.log(result);
    if (result.code === 0) {
      setProductData(result.data);
    }
  };

  useEffect(() => {
    handlerQueryAllApi();
  }, []);

  return (
    <div className={styles.gContainer1280_40}>
      {/* <div className={styles.defiLay}>
        <div className={styles.midTitle}>Defi</div>
        <div className={styles.ProductLay}>
          <MainProductItem setWidth="580px" />
          <MainProductItem setWidth="580px" />
        </div>
      </div> */}
      <div>
        <div className={styles.midTitle}>{t('algorithm_api')}</div>
        <div className={styles.subProductLay}>
          {productData.map(item => (
            <SubProductItem key={item.apiId} apiId={item.apiId} title={item.title} />))}
        </div>
      </div>
      {/* <div className={styles.all_topic}>
        <div className={styles.all_more_wrap}>
          <span>EXPLORE ALL TOPICS</span>
          <i className="iconfont iconjiantou" />
        </div>
      </div> */}
    </div>
  );
};
export default ProductHome;
